import React from "react";

export default function HRCalendar() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">HR Calendar</h1>
      <p>View company holidays, events, and important HR dates.</p>

      <ul className="mt-4 space-y-2">
        <li className="p-2 border rounded">🎄 Dec 25 – Christmas Holiday</li>
        <li className="p-2 border rounded">📅 Dec 31 – Year-End Performance Review</li>
        <li className="p-2 border rounded">📅 Jan 01 – New Year Holiday</li>
      </ul>
    </div>
  );
}
